<terra-dialog-header [showCloseButton]="false" class="no-border">
  <h1 [innerHTML]="context.title"></h1>
</terra-dialog-header>

<mat-dialog-content>
  <form [formGroup]="pageForm" id="pageForm" class="terra-error-style" mat-dialog-content>

    <div class="terra-form-field-wrapper">
      <label for="txtStartDate" class="text-input-label">From</label>
      <mat-form-field appearance="outline" class="remove-error-place">
        <input matInput id="txtStartDate" [matDatepicker]="startDatePicker" placeholder="{{context.startDatePlaceholder}}" [max]="startDateMax"
               formControlName="startDate" (focus)="startDatePicker.open()" class="lo_sensitive" (dateChange)="setEndDateMin($event.value)"/>
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="terra-form-field-wrapper">
      <label for="txtEndDate" class="text-input-label">To</label>
      <mat-form-field appearance="outline" class="remove-error-place">
        <input matInput id="txtEndDate" [matDatepicker]="endDatePicker" placeholder="{{context.endDatePlaceholder}}" [min]="endDateMin"
               formControlName="endDate" (focus)="endDatePicker.open()" class="lo_sensitive" (dateChange)="setStartDateMax($event.value)"/>
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker [startAt]="startDatePicker._getDateFilter()"></mat-datepicker>
      </mat-form-field>
    </div>

  </form>
</mat-dialog-content>

<div mat-dialog-actions class="dialog-action-buttons">
  <button mat-stroked-button color="primary" class="cov-button" mat-dialog-close cdkFocusInitial>{{context.cancelText}}</button>
  <button mat-flat-button color="primary" class="cov-button" (click)="apply()" [disabled]="pageForm.invalid">{{context.applyText}}</button>
</div>
